import { React } from 'Imports';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { isEncompass } from '$Utilities/integrationPlatform';

const styles = require(isEncompass ? './OfflineCameraBanner_Encompass.scss' : './OfflineCameraBanner_Geotab.scss') as {
    container: string;
    content: string;
    header: string;
    message: string;
};

export const OfflineCameraBanner = () => {
    const icon = isEncompass ? <FontAwesomeIcon icon={faExclamationCircle} color={'#7F4313'} /> : null;

    return (
        <div className={styles.container}>
            {icon}
            <div className={styles.content}>
                <div className={styles.header}>Camera is currently Offline.</div>
                <div className={styles.message}>
                    The system will attempt to wake it upon request. Otherwise, footage will be retrieved the next time the camera comes
                    online.
                </div>
            </div>
        </div>
    );
};

export default OfflineCameraBanner;
